export default __webpack_public_path__ + "static/media/twitter-white.cd98ddd5.png";